"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyPlusShortcut = void 0;
const react_1 = __importDefault(require("react"));
const SankeyPlusShortcut = () => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h4", { style: { textAlign: 'center' } }, "Raccourcis du module OpenSankey+"),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, "CTRL+S :"),
            "Sauvegarde la configuration actuelle dans une vue, qui peut ensuite \u00EAtre visualis\u00E9 dans le Menu Vue "),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, "CTRL+Click (Zone Texte) :"),
            "S\u00E9lectionne la zone click\u00E9 et ouvre le menu d'\u00E9dition de zone de texte ")));
};
exports.SankeyPlusShortcut = SankeyPlusShortcut;
